<template>
  <div></div>
</template>

<script>
export default {
  name: "genome_browser_page"
}
</script>

<style scoped>

</style>
